"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseToNumber = exports.getStyle = exports.default = void 0;
var _base = require("@mui/base");
var ReactDOM = _interopRequireWildcard(require("react-dom"));
var _styles = require("@mui/material/styles");
var _system = require("@mui/system");
var _utils = require("@mui/utils");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _masonryClasses = require("./masonryClasses");
var _jsxRuntime = require("react/jsx-runtime");
var parseToNumber = function(val) {
    return Number(val.replace('px', ''));
};
exports.parseToNumber = parseToNumber;
var lineBreakStyle = {
    flexBasis: '100%',
    width: 0,
    margin: 0,
    padding: 0
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'root'
        ]
    };
    return (0, _base.unstable_composeClasses)(slots, _masonryClasses.getMasonryUtilityClass, classes);
};
var getStyle = function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    var styles = {
        width: '100%',
        display: 'flex',
        flexFlow: 'column wrap',
        alignContent: 'flex-start',
        boxSizing: 'border-box',
        '& > *': {
            boxSizing: 'border-box'
        }
    };
    var stylesSSR = {};
    // Only applicable for Server-Side Rendering
    if (ownerState.isSSR) {
        var orderStyleSSR = {};
        var defaultSpacing = parseToNumber(theme.spacing(ownerState.defaultSpacing));
        for(var i = 1; i <= ownerState.defaultColumns; i += 1){
            orderStyleSSR["&:nth-of-type(".concat(ownerState.defaultColumns, "n+").concat(i % ownerState.defaultColumns, ")")] = {
                order: i
            };
        }
        stylesSSR.height = ownerState.defaultHeight;
        stylesSSR.margin = -(defaultSpacing / 2);
        stylesSSR['& > *'] = _object_spread_props(_object_spread({}, styles['& > *'], orderStyleSSR), {
            margin: defaultSpacing / 2,
            width: "calc(".concat((100 / ownerState.defaultColumns).toFixed(2), "% - ").concat(defaultSpacing, "px)")
        });
        return _object_spread({}, styles, stylesSSR);
    }
    var spacingValues = (0, _system.unstable_resolveBreakpointValues)({
        values: ownerState.spacing,
        breakpoints: theme.breakpoints.values
    });
    var transformer = (0, _system.createUnarySpacing)(theme);
    var spacingStyleFromPropValue = function(propValue) {
        var spacing;
        // in case of string/number value
        if (typeof propValue === 'string' && !Number.isNaN(Number(propValue)) || typeof propValue === 'number') {
            var themeSpacingValue = Number(propValue);
            spacing = (0, _system.getValue)(transformer, themeSpacingValue);
        } else {
            spacing = propValue;
        }
        return _object_spread({
            margin: "calc(0px - (".concat(spacing, " / 2))"),
            '& > *': {
                margin: "calc(".concat(spacing, " / 2)")
            }
        }, ownerState.maxColumnHeight && {
            height: typeof spacing === 'number' ? Math.ceil(ownerState.maxColumnHeight + parseToNumber(spacing)) : "calc(".concat(ownerState.maxColumnHeight, "px + ").concat(spacing, ")")
        });
    };
    styles = (0, _utils.deepmerge)(styles, (0, _system.handleBreakpoints)({
        theme: theme
    }, spacingValues, spacingStyleFromPropValue));
    var columnValues = (0, _system.unstable_resolveBreakpointValues)({
        values: ownerState.columns,
        breakpoints: theme.breakpoints.values
    });
    var columnStyleFromPropValue = function(propValue) {
        var columnValue = Number(propValue);
        var width = "".concat((100 / columnValue).toFixed(2), "%");
        var spacing = typeof spacingValues === 'string' && !Number.isNaN(Number(spacingValues)) || typeof spacingValues === 'number' ? (0, _system.getValue)(transformer, Number(spacingValues)) : '0px';
        return {
            '& > *': {
                width: "calc(".concat(width, " - ").concat(spacing, ")")
            }
        };
    };
    styles = (0, _utils.deepmerge)(styles, (0, _system.handleBreakpoints)({
        theme: theme
    }, columnValues, columnStyleFromPropValue));
    // configure width for responsive spacing values
    if ((typeof spacingValues === "undefined" ? "undefined" : _type_of(spacingValues)) === 'object') {
        styles = (0, _utils.deepmerge)(styles, (0, _system.handleBreakpoints)({
            theme: theme
        }, spacingValues, function(propValue, breakpoint) {
            if (breakpoint) {
                var themeSpacingValue = Number(propValue);
                var lastBreakpoint = Object.keys(columnValues).pop();
                var spacing = (0, _system.getValue)(transformer, themeSpacingValue);
                var column = (typeof columnValues === "undefined" ? "undefined" : _type_of(columnValues)) === 'object' ? columnValues[breakpoint] || columnValues[lastBreakpoint] : columnValues;
                var width = "".concat((100 / column).toFixed(2), "%");
                return {
                    '& > *': {
                        width: "calc(".concat(width, " - ").concat(spacing, ")")
                    }
                };
            }
            return null;
        }));
    }
    return styles;
};
exports.getStyle = getStyle;
var MasonryRoot = (0, _styles.styled)('div', {
    name: 'MuiMasonry',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        return [
            styles.root
        ];
    }
})(getStyle);
var Masonry = /*#__PURE__*/ React.forwardRef(function Masonry(inProps, ref) {
    var props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiMasonry'
    });
    var children = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, _props_columns = props.columns, columns = _props_columns === void 0 ? 4 : _props_columns, _props_spacing = props.spacing, spacing = _props_spacing === void 0 ? 1 : _props_spacing, _props_sequential = props.sequential, sequential = _props_sequential === void 0 ? false : _props_sequential, defaultColumns = props.defaultColumns, defaultHeight = props.defaultHeight, defaultSpacing = props.defaultSpacing, other = _object_without_properties(props, [
        "children",
        "className",
        "component",
        "columns",
        "spacing",
        "sequential",
        "defaultColumns",
        "defaultHeight",
        "defaultSpacing"
    ]);
    var masonryRef = React.useRef();
    var _React_useState = _sliced_to_array(React.useState(), 2), maxColumnHeight = _React_useState[0], setMaxColumnHeight = _React_useState[1];
    var isSSR = !maxColumnHeight && defaultHeight && defaultColumns !== undefined && defaultSpacing !== undefined;
    var _React_useState1 = _sliced_to_array(React.useState(isSSR ? defaultColumns - 1 : 0), 2), numberOfLineBreaks = _React_useState1[0], setNumberOfLineBreaks = _React_useState1[1];
    var ownerState = _object_spread_props(_object_spread({}, props), {
        spacing: spacing,
        columns: columns,
        maxColumnHeight: maxColumnHeight,
        defaultColumns: defaultColumns,
        defaultHeight: defaultHeight,
        defaultSpacing: defaultSpacing,
        isSSR: isSSR
    });
    var classes = useUtilityClasses(ownerState);
    var handleResize = React.useCallback(function(masonryChildren) {
        if (!masonryRef.current || !masonryChildren || masonryChildren.length === 0) {
            return;
        }
        var masonry = masonryRef.current;
        var masonryFirstChild = masonryRef.current.firstChild;
        var parentWidth = masonry.clientWidth;
        var firstChildWidth = masonryFirstChild.clientWidth;
        if (parentWidth === 0 || firstChildWidth === 0) {
            return;
        }
        var firstChildComputedStyle = window.getComputedStyle(masonryFirstChild);
        var firstChildMarginLeft = parseToNumber(firstChildComputedStyle.marginLeft);
        var firstChildMarginRight = parseToNumber(firstChildComputedStyle.marginRight);
        var currentNumberOfColumns = Math.round(parentWidth / (firstChildWidth + firstChildMarginLeft + firstChildMarginRight));
        var columnHeights = new Array(currentNumberOfColumns).fill(0);
        var skip = false;
        var nextOrder = 1;
        masonry.childNodes.forEach(function(child) {
            if (child.nodeType !== Node.ELEMENT_NODE || child.dataset.class === 'line-break' || skip) {
                return;
            }
            var childComputedStyle = window.getComputedStyle(child);
            var childMarginTop = parseToNumber(childComputedStyle.marginTop);
            var childMarginBottom = parseToNumber(childComputedStyle.marginBottom);
            // if any one of children isn't rendered yet, masonry's height shouldn't be computed yet
            var childHeight = parseToNumber(childComputedStyle.height) ? Math.ceil(parseToNumber(childComputedStyle.height)) + childMarginTop + childMarginBottom : 0;
            if (childHeight === 0) {
                skip = true;
                return;
            }
            // if there is a nested image that isn't rendered yet, masonry's height shouldn't be computed yet
            for(var i = 0; i < child.childNodes.length; i += 1){
                var nestedChild = child.childNodes[i];
                if (nestedChild.tagName === 'IMG' && nestedChild.clientHeight === 0) {
                    skip = true;
                    break;
                }
            }
            if (!skip) {
                if (sequential) {
                    columnHeights[nextOrder - 1] += childHeight;
                    child.style.order = nextOrder;
                    nextOrder += 1;
                    if (nextOrder > currentNumberOfColumns) {
                        nextOrder = 1;
                    }
                } else {
                    var _Math;
                    // find the current shortest column (where the current item will be placed)
                    var currentMinColumnIndex = columnHeights.indexOf((_Math = Math).min.apply(_Math, _to_consumable_array(columnHeights)));
                    columnHeights[currentMinColumnIndex] += childHeight;
                    var order = currentMinColumnIndex + 1;
                    child.style.order = order;
                }
            }
        });
        if (!skip) {
            // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
            // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
            // Related issue - https://github.com/facebook/react/issues/24331
            ReactDOM.flushSync(function() {
                var _Math;
                setMaxColumnHeight((_Math = Math).max.apply(_Math, _to_consumable_array(columnHeights)));
                setNumberOfLineBreaks(currentNumberOfColumns > 0 ? currentNumberOfColumns - 1 : 0);
            });
        }
    }, [
        sequential
    ]);
    (0, _utils.unstable_useEnhancedEffect)(function() {
        // IE and old browsers are not supported
        if (typeof ResizeObserver === 'undefined') {
            return undefined;
        }
        var animationFrame;
        var resizeObserver = new ResizeObserver(function() {
            // see https://github.com/mui/material-ui/issues/36909
            animationFrame = requestAnimationFrame(handleResize);
        });
        if (masonryRef.current) {
            masonryRef.current.childNodes.forEach(function(childNode) {
                resizeObserver.observe(childNode);
            });
        }
        return function() {
            if (animationFrame) {
                cancelAnimationFrame(animationFrame);
            }
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [
        columns,
        spacing,
        children,
        handleResize
    ]);
    var handleRef = (0, _utils.unstable_useForkRef)(ref, masonryRef);
    //  columns are likely to have different heights and hence can start to merge;
    //  a line break at the end of each column prevents columns from merging
    var lineBreaks = new Array(numberOfLineBreaks).fill('').map(function(_, index) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            "data-class": "line-break",
            style: _object_spread_props(_object_spread({}, lineBreakStyle), {
                order: index + 1
            })
        }, index);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(MasonryRoot, _object_spread_props(_object_spread({
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        ref: handleRef,
        ownerState: ownerState
    }, other), {
        children: [
            children,
            lineBreaks
        ]
    }));
});
process.env.NODE_ENV !== "production" ? Masonry.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default/* @typescript-to-proptypes-ignore */ .node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * Number of columns.
   * @default 4
   */ columns: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.number,
            _propTypes.default.string
        ])),
        _propTypes.default.number,
        _propTypes.default.object,
        _propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: _propTypes.default.elementType,
    /**
   * The default number of columns of the component. This is provided for server-side rendering.
   */ defaultColumns: _propTypes.default.number,
    /**
   * The default height of the component in px. This is provided for server-side rendering.
   */ defaultHeight: _propTypes.default.number,
    /**
   * The default spacing of the component. Like `spacing`, it is a factor of the theme's spacing. This is provided for server-side rendering.
   */ defaultSpacing: _propTypes.default.number,
    /**
   * Allows using sequential order rather than adding to shortest column
   * @default false
   */ sequential: _propTypes.default.bool,
    /**
   * Defines the space between children. It is a factor of the theme's spacing.
   * @default 1
   */ spacing: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.number,
            _propTypes.default.string
        ])),
        _propTypes.default.number,
        _propTypes.default.object,
        _propTypes.default.string
    ]),
    /**
   * Allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ])
} : void 0;
var _default = exports.default = Masonry;
